import { Component } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { Location } from '@angular/common';
import { AppService } from './app.service';
import { User } from './models/user';
import { NgbModalRef, NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  private login: string;
  private user: User = new User();
  private errorModal: NgbModalRef;
  private errors: string[];
  private affiche;

  constructor(private location: Location, private appService: AppService, private modalService: NgbModal, private router: Router) {
  }

  ngOnInit() {
    this.affiche = false;
    let path: string = this.location.path();
    if (path.indexOf('login=') !== -1 && path.indexOf('4h') !== -1 && path.indexOf('2j') !== -1 && path.indexOf('3x') !== -1) {
      var result: number = Number(path.substring(path.indexOf('4h') + 2, path.indexOf('2j')));
      var coef = Number(path.substring(path.indexOf('2j') + 2, path.indexOf('3x')));
      var rdm = Number(path.substring(path.indexOf('3x') + 2, path.length));
      var total: number = coef * (new Date().getDay() + 1) * rdm;

      if (total === result && result !== 0) {
        this.login = path.substring(path.indexOf('login=') + 6, path.indexOf('4h'));
        this.appService.getUser(this.login).subscribe(userCourant => {
          if (!userCourant || userCourant.id === '-1') {
            this.errors = [];
            this.errors.push('Utilisateur inconnu');
            this.openModal();
          } else {
            this.appService.userCourant = userCourant;
            this.appService.getActu().subscribe(actu =>
              {
                this.appService.actu=actu;
                this.affiche = true;
                this.router.navigate(['/accueil']);
              });
          }
        });
      } else {
        window.location.assign("http://sagedijon.fr");
      }   
    } else {
      window.location.assign("http://sagedijon.fr");
    }
  }

  openModal() {
    this.errorModal = this.modalService.open(this.appService.errorModal, { size: 'lg', backdrop: 'static', keyboard: false });
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts